"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.general.title': 'Impostazioni Generali',
    'settings.general.description': 'Configura le impostazioni della tua applicazione e le integrazioni',
    'settings.general.tabs.googleDrive': 'Google Drive',
    'settings.general.tabs.general': 'Generale',
    'settings.general.tabs.apiKeys': 'Chiavi API',
    'settings.general.tabs.rag': 'Configurazione RAG',
    'settings.general.tabs.credit': 'Impostazioni Crediti',
    'settings.general.tabs.socialMedia': 'Social Media',
    'settings.general.generalSettings.comingSoon': 'Le impostazioni generali saranno disponibili presto.',
    'settings.general.apiKeys.comingSoon': 'La gestione delle chiavi API sarà disponibile presto.',
    'settings.general.chatLearning.title': 'Riepilogo Apprendimento Chat',
    'settings.general.chatLearning.description': 'Gestisci il tuo riepilogo di apprendimento AI personalizzato. Queste informazioni aiutano l\'AI a fornire risposte migliori e più mirate.',
    'settings.general.chatLearning.summaryLabel': 'Riepilogo Apprendimento',
    'settings.general.chatLearning.summaryPlaceholder': 'Inserisci o modifica informazioni sulle tue preferenze, contesto e dettagli importanti che dovrebbero aiutare l\'AI ad assisterti meglio...',
    'settings.general.chatLearning.summaryHelp': 'Questo riepilogo viene aggiornato automaticamente basandosi sulle tue conversazioni. Puoi modificarlo manualmente per includere preferenze specifiche o contesto.',
    'settings.general.save': 'Salva Impostazioni',
    'settings.general.reload': 'Ricarica',
    'settings.general.savedSuccessfully': 'Impostazioni generali salvate con successo',
    'settings.general.failedToSave': 'Errore nel salvare le impostazioni generali',
    'settings.general.failedToLoad': 'Errore nel caricare le impostazioni generali',
};
